import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./Layout.scss";
import React from "react";
import { TopBar } from "../TopBar/TopBar";
import SideNav from "../navigation/SideNav";
export const Layout = ({ children, fullHeight = false }) => {
    // The nav owns its own responsive mode and collapse preference (see
    // navigation/nav-store.ts + useNavMode.ts) and publishes the result on
    // <body data-nav-mode>, so the content column offsets itself in CSS and
    // toggling the sidebar no longer re-renders every page under Layout.
    return (_jsxs(_Fragment, { children: [_jsx(SideNav, {}), _jsxs("main", { className: `layout-main${fullHeight ? " fixed-height" : ""}`, children: [_jsx(TopBar, {}), children] })] }));
};
